
export const createGameSlug = (title: string): string => {
  return title
    .toLowerCase()
    // Replace special characters and spaces with hyphens
    .replace(/[^a-z0-9\s-]/g, '')
    // Replace multiple spaces with single space
    .replace(/\s+/g, ' ')
    // Trim whitespace
    .trim()
    // Replace spaces with hyphens
    .replace(/\s/g, '-')
    // Replace multiple hyphens with single hyphen
    .replace(/-+/g, '-')
    // Remove leading/trailing hyphens
    .replace(/^-+|-+$/g, '');
};

export const createGameUrl = (title: string): string => {
  const slug = createGameSlug(title);
  return `/game/${slug}`;
};

export const createGameUrlById = (gameId: string, title: string): string => {
  const slug = createGameSlug(title);
  return `/game/${gameId}/${slug}`;
};

export const extractGameIdFromUrl = (url: string): string | null => {
  const match = url.match(/\/game\/([^\/]+)/);
  return match ? match[1] : null;
};

export const extractGameSlugFromUrl = (url: string): string | null => {
  const match = url.match(/\/game\/([^\/]+)$/);
  return match ? match[1] : null;
};

// Convert SEO slug back to likely title format for database lookup
export const slugToTitle = (slug: string): string => {
  return slug
    .split('-')
    .map(word => {
      // Handle common words that should remain lowercase
      const lowercaseWords = ['a', 'an', 'the', 'and', 'or', 'but', 'in', 'on', 'at', 'to', 'for', 'of', 'with', 'by'];
      if (lowercaseWords.includes(word.toLowerCase())) {
        return word.toLowerCase();
      }
      // Capitalize first letter of other words
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ')
    // Ensure first word is always capitalized
    .replace(/^[a-z]/, match => match.toUpperCase());
};
